// extracted by mini-css-extract-plugin
export var label = "_hk-2";
export var slideContainer = "_hk-0";
export var slider = "_hk-1";